import { useState } from "react";
import { useAuth } from "../../hooks/AuthContext";
import { SubmitButton } from "../shared/buttons/submit-button";
import Input from "../shared/input";
import Typography from "../shared/typography";
import {
  ThemedFormContainer,
  ThemedFormSection,
} from "../shared/forms";

const ChangePasswordForm = () => {
  const { updatePassword } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [status, setStatus] = useState<"idle" | "success">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("idle");
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setError("");
    await updatePassword(password);
    setPassword("");
    setConfirm("");
    setStatus("success");
  };

  return (
    <ThemedFormContainer
      onSubmit={handleSubmit}
      title="Change Password"
      description="Update your admin credentials to keep your account secure."
      errorMessage={error || undefined}
      successMessage={
        status === "success"
          ? "Password updated successfully."
          : undefined
      }
      footer={
        <div className="flex w-full flex-col items-stretch gap-3 sm:w-auto sm:flex-row sm:items-center">
          <SubmitButton isDisabled={!password || !confirm}>
            Update Password
          </SubmitButton>
        </div>
      }
      cardClassName="max-w-2xl"
      formClassName="w-full"
    >
      <ThemedFormSection
        title="New credentials"
        description="Choose a unique password that's at least 8 characters long."
        footer={
          <Typography variant="caption" className="text-brown-600">
            Pro tip: mix letters, numbers, and symbols for a stronger password.
          </Typography>
        }
      >
        <Input
          id="new-password"
          type="password"
          label="New Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (error) {
              setError("");
            }
            if (status === "success") {
              setStatus("idle");
            }
          }}
          fullWidth
        />
        <Input
          id="confirm-password"
          type="password"
          label="Confirm Password"
          value={confirm}
          onChange={(e) => {
            setConfirm(e.target.value);
            if (error) {
              setError("");
            }
            if (status === "success") {
              setStatus("idle");
            }
          }}
          fullWidth
        />
      </ThemedFormSection>
    </ThemedFormContainer>
  );
};

export default ChangePasswordForm;
